import React from 'react'

function NoResourceMessage() {

    const containerStyle = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "2rem",
        textAlign: "center",
    };
    
    const messageStyle = {
        fontSize: "2rem",
        color: "#666",
        marginTop: "1rem",
    };
    
  return (
    <div style={containerStyle}>
        <div style={{ fontSize: "4rem" }}>😿</div>
        <div style={messageStyle}>No resources available right now. Check back soon!</div>
    </div>
  )
}

export default NoResourceMessage